// Keep the Email line implementation in place while it is temporarily hidden.
// Change this to true when the standalone All Projects line should return.
export const EMAIL_LINE_ENABLED = false
